import { Subscriber } from 'types/electionService';
import { SubscriberBasicInfo, SubscriberPersonInfo } from './types';

const DEPENDENT_TYPE_ORDER: Record<string, number> = { S: 3, DP: 2, D: 1 };

export function sortDependents(dependents: SubscriberPersonInfo[]): SubscriberPersonInfo[] {
  return [...dependents].sort((a, b) => {
    const aOrder = DEPENDENT_TYPE_ORDER[a.type] ?? 0;
    const bOrder = DEPENDENT_TYPE_ORDER[b.type] ?? 0;
    if (aOrder > bOrder) return -1;
    if (aOrder < bOrder) return 1;
    if (a.type === 'D' && b.type === 'D') {
      return a.firstName.localeCompare(b.firstName);
    }
    return 0;
  });
}

/** Maps a BE `Subscriber` into the primary+dependents domain model. */
export function mapSubscriberToBasicInfo(
  subscriber: Pick<Subscriber, 'id' | 'common' | 'custom'>,
): SubscriberBasicInfo {
  return {
    id: subscriber.id,
    primary: { ...subscriber.common },
    dependents: sortDependents(subscriber.custom.dependents ?? []),
  };
}
